import SEOHead from "@/components/SEOHead";
import CashVsCardComparator from "@/components/CashVsCardComparator";
import TrustBar from "@/components/TrustBar";
import RelatedTools from "@/components/RelatedTools";
import SolutionsCrossSell from "@/components/SolutionsCrossSell";

export default function CashVsCardPage() {
  return (
    <div>
      <SEOHead title="Cash vs Card Comparator" description="Compare the real cost of handling cash versus taking card payments. Free calculator — see the difference instantly." path="/cash-vs-card" />

      <section className="py-10 md:py-16 bg-gray-50" id="comparator" data-testid="calculator-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-aqua mb-2">Cash vs Card</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight mb-3">Which really costs more?</h1>
            <p className="text-brand-grey leading-relaxed max-w-xl mx-auto">Compare cash handling costs against card processing costs side by side. Instant, free, no sign-up.</p>
          </div>
          <CashVsCardComparator />
        </div>
      </section>

      <TrustBar />

      <RelatedTools currentPath="/cash-vs-card" />
      <SolutionsCrossSell currentPath="/cash-vs-card" />
    </div>
  );
}
